/*global location*/
function redirectToModule({ input }) {
  window.location.href = input.result.redirect
}

export default redirectToModule



// WEBPACK FOOTER //
// ./src/modules/login/actions/redirectToModule.js